import React, { lazy } from "react";
import Loadable from "components/shared/loadable";
import MainLayout from "layout/main-layout";
import { RequireAuth } from "hooks/useInfoContext";
import ReceiveCard from "pages/receiveCard";
import MyProfile from "pages/myProfile";
import Invite from "pages/invite";
import AcceptingRules from "pages/acceptingRules";
import NationalId from "pages/nationalId";
import RegisterConcert from "pages/registerConcert";

const Home = Loadable(lazy(() => import("pages/home")));
const OnCard = Loadable(lazy(() => import("pages/onCard")));
const CardActivation = Loadable(lazy(() => import("pages/cardActivation")));
const NotFound = Loadable(lazy(() => import("pages/not-found")));
const EditAccount = Loadable(lazy(() => import("pages/editAccount")));

const MainRoutes = {
  path: "/",
  element: (
    <RequireAuth>
      <MainLayout />
    </RequireAuth>
  ),
  children: [
    {
      index: true,
      element: <Home />,
    },
    {
      path: '/national-id',
      element: <NationalId />,
    },
    {
      path: "/edit-account",
      element: <EditAccount />,
    },
    {
      path: "/edit-account",
      element: <EditAccount />,
    },
    {
      path: "/on-card",
      element: <OnCard />,
    },
    {
      path: "/card-activation",
      element: <CardActivation />,
    },
    {
      path: "/receive-card",
      element: <ReceiveCard />,
    },
    {
      path: "/my-profile",
      element: <MyProfile />,
    },
    {
      path: "/invite-friends",
      element: <Invite />,
    },
    {
      path: "/accpecting-rules",
      element: <AcceptingRules />,
    },
    {
      path: "/register-concert",
      element: <RegisterConcert />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ],
};

export default MainRoutes;

// const AppRoutes = () => {
//   let width = window.screen.width;
//   const isMobile = width <= 768;
//   const navigate = useNavigate();

//   useEffect(() => {
//     const refreshToken = getRefreshTokenCookie();
//     if (!refreshToken) {
//       navigate("/login");
//     }
//   }, [navigate]);

//   return (
//     <Routes>
//       <Route path="/login" element={<Login />} />
//       <Route path="/personalInfo" element={<PersonalInfo />} />
//       <Route path="/country" element={<SelectCountry />} />
//       <Route path="/postalcode/:country" element={<PostalCode />} />
//       <Route path="/cardIssuance" element={<CardIssuance />} />

//       {isMobile && (
//         <>
//           <Route path="/" element={<HomePage />} />
//           <Route path="/cardActivation" element={<CardActivation />} />
//           <Route path="/onCard" element={<OnCard />} />
//         </>
//       )}

//       {!isMobile && (
//         <Route path="/" element={<HomeLayout />}>
//           <Route path="cardActivation" element={<CardActivation />} />
//           <Route path="/onCard" element={<OnCard />} />
//         </Route>
//       )}
//     </Routes>
//   );
// };

// export default AppRoutes;
